
const digest = 'ade573ad49704d7350068a2aa08fd29ff6b9e72739020532e2be9f9bc8e9d5d3';
const classes = {"p":"_p_1f5aa_1"};
const css = `._p_1f5aa_1 {
  font-family: Poppins, sans-serif;
  margin: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  